import {
  Datagrid,
  TextField as RaTextField,
  FunctionField,
  Record as RaRecord,
  RowClickFunction,
  useListContext,
  DatagridLoading,
  useDatagridStyles,
} from "react-admin";
import {
  getBackgroundColor,
  getColor,
} from "../../../hos/logs/driver-logs/eventUtils";
import ColoredStatusField from "../../data-grid-fields/ColoredStatusField";
import TimeField from "../../data-grid-fields/TimeField";
import { Theme, useTheme } from "@material-ui/core/styles";
import { ViewEventDto } from "../../../../common/data/service-proxies";
import { parseISO } from "date-fns";
import { Typography } from "@material-ui/core";

interface Props {
  handleRowClick: RowClickFunction;
  timeZone?: string;
}

export const EventPickerDataGrid = ({ handleRowClick, timeZone }: Props) => {
  const theme = useTheme<Theme>();
  const { loading } = useListContext();
  const classes = useDatagridStyles();

  return loading ? (
    <DatagridLoading
      classes={classes}
      hasBulkActions={false}
      nbChildren={5}
      size="small"
    />
  ) : (
    <Datagrid hasBulkActions={false} rowClick={handleRowClick} optimized>
      <RaTextField source="number" label="#" />
      <FunctionField<ViewEventDto & RaRecord>
        label="Start time"
        render={(record) =>
          record ? (
            <Typography variant="body2">
              {parseISO(record.startTime!).toLocaleTimeString("en-US", {
                timeZone,
              })}
            </Typography>
          ) : null
        }
      />
      <ColoredStatusField
        color={(record, source, _) => getColor(record, source, theme)}
        backgroundColor={(record, source, _) =>
          getBackgroundColor(record, source, theme)
        }
        applyColorTo="everything"
        labelStyle="columns"
        source="dutyStatus"
        labelTranslationNamespace="appData.dutyCycles"
      />
      <TimeField
        label="Duration"
        source="durationInSeconds"
        inputType="seconds"
        outputType="long"
        emptyDisplay="-"
      />
      <RaTextField source="locationDisplayName" label="Location" />
      <RaTextField source="notes" label="Notes" />
    </Datagrid>
  );
};
